export const GET_ALL_GRID = '/api/grid/get-all-grids';
export const GRID_COLUMN_INFO = '/api/grid/grid-column-info';
export const SAVE_GRID_CONFIG = '/api/grid/save-grid-config';
export const GET_LIST_GRID_CONFIGS = '/api/grid/get-list-grid-configs';
export const DELETE_GRID_CONFIG = '/api/grid/delete-grid-config';
export const GET_DEFAULT_GRID_CONFIG = '/api/grid/get-default-grid-config';
export const SET_DEFAULT_GRID_CONFIG = '/api/grid/set-default-grid-config';
export const GET_TODO_LIST = '/api/workflow/get-todo-list';
export const RESOLVE_TODO_LIST = '/api/workflow/accept-or-reject-todo-list';
